import axios from 'axios';

import { env } from 'env';

const { REACT_APP_API_URL } = env;

export default class AvaturnService {
  static async magicMirror(props: {
    avaturnId: string;
    avatarId: string;
    brand: string;
    gender: string;
    persona?: string;
    status: string;
  }) {
    return axios
      .post(`${REACT_APP_API_URL}api/v2/ixr/sd/magicMirror`, props)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in magicMirror:', error);
        throw error;
      });
  }

  static async changeAvatar(props: {
    avatarId: string;
    brand: string;
    ixrCredentialStatus: string;
    gender: string;
    persona?: string;
    tags: string[];
  }) {
    const url = `${REACT_APP_API_URL}api/v2/avatar/avaturn/changeAvatar`;

    return axios
      .post(url, props)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in changeAvatar:', error);
        throw error;
      });
  }

  static async cloneAvatar(props: {
    avatarId: string;
    brand: string;
    ixrCredentialStatus?: string;
    gender: string;
    persona?: string;
    tags?: string[];
    renderPic: boolean;
  }) {
    const url = `${REACT_APP_API_URL}api/v2/avatar/avaturn/copyAvatar`;

    return axios
      .post(url, props)
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in cloneAvatar:', error);
        throw error;
      });
  }
}
